import { render, staticRenderFns } from "./middleBottom.vue?vue&type=template&id=12fb3db4&scoped=true&"
import script from "./middleBottom.vue?vue&type=script&lang=js&"
export * from "./middleBottom.vue?vue&type=script&lang=js&"
import style0 from "./middleBottom.vue?vue&type=style&index=0&id=12fb3db4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb3db4",
  null
  
)

export default component.exports